import { useEffect, useRef, useState } from 'react';

export function useDisclosureChecked({ disclosures, initialCheckedIds, onCheckedChange }) {
  const [checkedById, setCheckedById] = useState({});
  const initialCheckedIdsRef = useRef(initialCheckedIds);

  useEffect(() => {
    if (disclosures.length === 0) return;
    const initial = new Set(initialCheckedIdsRef.current.map(String));
    setCheckedById(
      Object.fromEntries(
        disclosures.map((d) => [d.id, d.is_required || initial.has(String(d.id))]),
      ),
    );
  }, [disclosures]);

  useEffect(() => {
    initialCheckedIdsRef.current = initialCheckedIds;
  }, [initialCheckedIds]);

  useEffect(() => {
    onCheckedChange?.(disclosures.filter((d) => checkedById[d.id]));
  }, [checkedById, disclosures, onCheckedChange]);

  const onToggle = (id, checked) => setCheckedById((prev) => ({ ...prev, [id]: checked }));

  return { checkedById, onToggle };
}
